

























import Vue from "vue";
import MoneyInput from "@/components/MoneyInput.vue";
import { getWeight, InvoiceItem } from "../models";

interface Props {
  item: InvoiceItem;
}

export default Vue.extend<{}, {}, {}, Props>({
  components: { MoneyInput },

  props: {
    item: {
      type: Object as () => InvoiceItem,
    },
  },

  computed: {
    weight(): number {
      return getWeight(this.item.relations[0].relatedItem, this.item.quantity);
    },
  },
});
